import {mapState} from "vuex";

import { FRONTEND_URL } from "./const";

export const Body = {
    data() {
        return {
            sidebarLoaded: false,
            editingProcess: false,
        }
    },
    created() {
        this.$store.dispatch('currentUser/fetch');
        this.axios.interceptors.response.use((response) => {
            if (response.data.status === 'error') {
                return this.handleErrors(response)
            }
            return response;
        }, (error) => {
            if (error.response) {
                if (error.response.status === 400) {
                    return error.response
                }
                return this.showErrorDialog(error.response.data);
            }
            return Promise.reject(error)
        })
        this.$bus.listen('editingProcess', () => {
            this.editingProcess = true
            this.$bus.fire('focusOnElement')
        })
        this.$bus.listen('stopEditingProcess', () => {
            this.$nextTick().then(() => {
                this.editingProcess = false
            })
        })
    },

    methods: {
        fireEsc() {
            if (!this.editingProcess) {
                let $comp = this.$store.getters['hideComponent/last']

                if ($comp){
                    let id = $comp.$el ? $comp.$el.id : null
                    this.$bus.fire('esc', id)
                }


                // Для диалогов отдельная логика
                if ($comp && ($comp.$options._componentTag !== 'v-dialog' || $comp.$options._componentTag !== 'v-dialog-old')) {
                    $comp.visible = false
                }
            }
        },

        handleErrors (response) {
            let error = response.data
            let type = error.type
            switch (type) {
                case 'auth':
                case 'identifier':
                    this.showIdentifierErrorDialog(error)
                    break
                case 'access':
                    this.showAccessDeniedDialog(error)
                    break
                case 'notfound':
                case 'unhandled':
                case 'validation':
                    this.showErrorDialog(error)
                    break
                case 'sql':
                    this.showSqlErrorDialog()
                    break

                default:
                    break
            }
            return Promise.reject(error)
        },

        handleErrorsOnCode () {
            let status = error.status
            switch (status) {
                case 500:
                    console.error("Something gone wrong, received 500 code with data: ", error.response.data)
                    break

                case 401:
                    // Необходимо повторно войти в систему.
                    console.log(this, 'Необходимо повторно войти в систему.')
                    break
                case 402:
                    // Недостаточный баланс!
                    console.log(this, 'Необходимо повторно войти в систему.')
                    break
                case 403:
                    this.showAccessDeniedDialog(error)
                    break
                case 423:
                    this.showAccessDeniedDialog(error)
                    break
                case 521:
                    // Ведутся технические работы
                    console.log(this, 'Необходимо повторно войти в систему.')
                    break
            }
            return Promise.reject(error)
        },
        resetPassword(email) {
            this.$modal(`Новый пароль будет отправлен на почту ${email}. Продолжить?`, {
                name: 'Да',
                callback: () => {
                    this.axios.post('/forgot-password', {
                        userEmail: email,
                    }).then((res) => {console.log(res.data)})
                }
            }, {
                name: 'Нет',
            });
        },
        showNotFoundDialog (error) {
            this.$refs.dialogNotFoundError.show(error)
        },
        pwgen () {
            let result = null;

            while (!result) {
                result = generate0();
            }
            return result;

            function generate0() {
                let maxLength = 8;
                let includeCapitalLetter = false;
                let includeNumber = true;

                let INCLUDE_NUMBER = 1;
                let INCLUDE_CAPITAL_LETTER = 1 << 1;
                let CONSONANT = 1;
                let VOWEL = 1 << 1;
                let DIPTHONG = 1 << 2;
                let NOT_FIRST = 1 << 3;

                let ELEMENTS = [
                    ["a", VOWEL],
                    ["ae", VOWEL | DIPTHONG],
                    ["ah", VOWEL | DIPTHONG],
                    ["ai", VOWEL | DIPTHONG],
                    ["b", CONSONANT],
                    ["c", CONSONANT],
                    ["ch", CONSONANT | DIPTHONG],
                    ["d", CONSONANT],
                    ["e", VOWEL],
                    ["ee", VOWEL | DIPTHONG],
                    ["ei", VOWEL | DIPTHONG],
                    ["f", CONSONANT],
                    ["g", CONSONANT],
                    ["gh", CONSONANT | DIPTHONG | NOT_FIRST],
                    ["h", CONSONANT],
                    ["i", VOWEL],
                    ["ie", VOWEL | DIPTHONG],
                    ["j", CONSONANT],
                    ["k", CONSONANT],
                    ["l", CONSONANT],
                    ["m", CONSONANT],
                    ["n", CONSONANT],
                    ["ng", CONSONANT | DIPTHONG | NOT_FIRST],
                    ["o", VOWEL],
                    ["oh", VOWEL | DIPTHONG],
                    ["oo", VOWEL | DIPTHONG],
                    ["p", CONSONANT],
                    ["ph", CONSONANT | DIPTHONG],
                    ["qu", CONSONANT | DIPTHONG],
                    ["r", CONSONANT],
                    ["s", CONSONANT],
                    ["sh", CONSONANT | DIPTHONG],
                    ["t", CONSONANT],
                    ["th", CONSONANT | DIPTHONG],
                    ["u", VOWEL],
                    ["v", CONSONANT],
                    ["w", CONSONANT],
                    ["x", CONSONANT],
                    ["y", CONSONANT],
                    ["z", CONSONANT]
                ];

                let result = "";
                let prev = 0;
                let isFirst = true;

                let requested = 0;
                if (includeCapitalLetter) {
                    requested |= INCLUDE_CAPITAL_LETTER;
                }

                if (includeNumber) {
                    requested |= INCLUDE_NUMBER;
                }

                let shouldBe = (Math.random() < 0.5) ? VOWEL : CONSONANT;

                while (result.length < maxLength) {
                    let i = Math.floor((ELEMENTS.length - 1) * Math.random());
                    let str = ELEMENTS[i][0];
                    let flags = ELEMENTS[i][1];

                    /* Filter on the basic type of the next element */
                    if ((flags & shouldBe) == 0) {
                        continue;
                    }
                    /* Handle the NOT_FIRST flag */
                    if (isFirst && (flags & NOT_FIRST)) {
                        continue;
                    }
                    /* Don't allow VOWEL followed a Vowel/Dipthong pair */
                    if ((prev & VOWEL) && (flags & VOWEL) && (flags & DIPTHONG)) {
                        continue;
                    }
                    /* Don't allow us to overflow the buffer */
                    if (result.length + str.length > maxLength) {
                        continue;
                    }


                    if (requested & INCLUDE_CAPITAL_LETTER) {
                        if ((isFirst || (flags & CONSONANT)) &&
                            (Math.random() > 0.3))
                        {
                            str = str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
                            requested &= ~INCLUDE_CAPITAL_LETTER;
                        }
                    }

                    /*
                     * OK, we found an element which matches our criteria,
                     * let's do it!
                     */
                    result += str;


                    if (requested & INCLUDE_NUMBER) {
                        if (!isFirst && (Math.random() < 0.3)) {
                            result += Math.floor(10 * Math.random()).toString();
                            requested &= ~INCLUDE_NUMBER;

                            isFirst = true;
                            prev = 0;
                            shouldBe = (Math.random() < 0.5) ? VOWEL : CONSONANT;
                            continue;
                        }
                    }

                    /*
                     * OK, figure out what the next element should be
                     */
                    if (shouldBe == CONSONANT) {
                        shouldBe = VOWEL;
                    } else { /* should_be == VOWEL */
                        if ((prev & VOWEL) ||
                            (flags & DIPTHONG) || (Math.random() > 0.3))
                        {
                            shouldBe = CONSONANT;
                        } else {
                            shouldBe = VOWEL;
                        }
                    }
                    prev = flags;
                    isFirst = false;
                }

                if (requested & (INCLUDE_NUMBER | INCLUDE_CAPITAL_LETTER)) {
                    return null;
                }

                return result;
            }
        },
        showAccessDeniedDialog (error) {
            this.$refs.dialogAccessDeniedError.show(error);
        },
        showSqlErrorDialog () {
            this.$modal('<h2><i class="fa fa-warning text-red" style="margin-right: 11px;"></i>Произошла ошибка</h2>', {
                name: 'ОК',
                btnClass: 'red',
                callback: () => {},
            }, {}, false, 'only-text-dialog');
        },
        showErrorDialog (error) {
            this.$refs.dialogError.show(error);
        },
        showIdentifierErrorDialog (error) {
            this.$refs.dialogError.show(error, {reloadBtn: true});
        },
        beforeunloadEvent(e) {
                let confirmationMessage = 'Изменения не сохранены.';
                (e || window.event).returnValue = confirmationMessage; //Gecko + IE
                return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
        },
        getQueryVariable (variable) {
            let query = window.location.hash.substring(1);
            let vars = query.split('&');
            for (let i = 0; i < vars.length; i++) {
                let pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) === variable) {
                    return decodeURIComponent(pair[1]);
                }
            }
            return null;
        },
        getCookie (name) {
            let nameEQ = name + "=";
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        },
        hasCookie (name) {
            return this.getCookie(name) !== null
        }
    },
    computed: {
        frontendUrl: function () {
            return FRONTEND_URL;
        }
    }
};
